import Photos from './Photos'
import Albums from './Albums'

export { Photos, Albums }


/** WEBPACK FOOTER **
 ** ./src/components/Media/Photos/index.js
 **/